import {
    GET_BETA_STATION,
    GET_BETA_STATION_SUCCESS,
 } from './betaStationConstant';


 export const fetchBetaStationAction = (stationCode = "", companyCode = "") => ({
    type: GET_BETA_STATION,
    stationCode,
    companyCode
 });

export const fetchBetaStationSuccess = (response) => ({
    type: GET_BETA_STATION_SUCCESS,
    data: response
})
